import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import { defValueBanco, TBancos } from "../../types/api/financeiro/bancos";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectBancos({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange,
    disabled = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.codigo} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error, disabled }}
                label={`Selecionar banco`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar banco"
                        queryPath="/financeiro/configuracoes/pesquisar-bancos"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.codigo} - ${item.nome}`}
                        defaultValue={value || defValueBanco}
                        onChange={(value) => {
                            onChange(value as TBancos)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TBancos | null | undefined
    onChange: (arg: TBancos | null) => void
    required?: boolean
    error?: boolean
    errorMessage?: string | undefined
    disabled?: boolean
}